import React from "react";
import Proptypes from "prop-types";
import styled from "styled-components";
import { BreadCrumb as PRBreadCrumb } from "primereact/breadcrumb";
import { compose, space, layout, flexbox, position } from "styled-system";

const StyledBreadcrumb = styled(PRBreadCrumb)`
  ${compose(space, flexbox, layout, position)};
  border: none;
  background-color: var(--transparent);
  padding: 0;
  padding-bottom: var(--regular-spacing);
  a {
    box-shadow: none !important;
  }
  .p-breadcrumb-chevron {
    display: none;
  }
  .p-menuitem-text {
    font-size: var(--fs-micro);
    line-height: var(--fs-milli);
    padding-right: var(--xs-spacing);
    color: var(--text) !important;
  }
  .p-breadcrumb-home {
    display: none;
  }
`;

const Breadcrumb = (props) => {
  const { items, home } = props;

  return <StyledBreadcrumb model={items} home={home} {...props} />;
};

Breadcrumb.propTypes = {
  items: Proptypes.array,
  home: Proptypes.object,
};

export default Breadcrumb;
